<div id="mail-confirm" fxLayout="column">

    <div id="mail-confirm-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="mail-confirm-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <mat-icon class="mat-accent s-96">email</mat-icon>
            </div>

            <div class="title">{{title}}</div>

            <div class="subtitle">
                <p *ngIf="!registeredWithSocial">
                    {{'Password has been sent to' | translate }} <b>{{processedEmail}}</b>.
                </p>
                <p *ngIf="registeredWithSocial">
                    {{'Your account is successfully registered with' | translate }} <b>{{registeredWithSocial}}</b>.
                </p>
                <p>
                    {{'Check your inbox.' | translate }}
                </p>
            </div>

            <div class="message">
                <a class="link" [routerLink]="'/login'">{{'Go back to login' | translate }}</a>
            </div>

        </div>

    </div>

</div>